<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i :class="serialNumber.id == null ? 'bi bi-plus-lg' : 'bi bi-pencil'"></i>
        {{ serialNumber.id == null ? 'Nuevo numero de serie' : 'Editar numero de serie ID ' + serialNumberId }}
      </h6>
      <button
        v-if="serialNumber.id != null"
        type="button"
        class="form-card__btn"
        @click="resetForm()"
      >
        <i class="bi bi-plus-lg"></i>
        Nuevo
      </button>
    </div>

    <div class="form-card__body">
      <form @submit.prevent>
        <div class="form-card__field">
          <label class="form-card__label" for="input-live">Numero de serie</label>
          <input
            id="input-live"
            v-model.trim="serialNumber.code"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': codeState === false }"
            placeholder="Numero de serie"
          >
          <div v-if="codeState === false" class="form-card__error">
            El numero de serie debe tener un mínimo de 3 letras
          </div>
          <div v-else class="form-card__hint">Campo obligatorio</div>
        </div>

        <div class="form-card__field">
          <label class="form-card__label">Proveedor</label>
          <typeahead
            :key="'provider-' + formKey"
            :name="'provider'"
            :placeh="'Buscar proveedor por nombre...'"
            :clean-on="false"
            :state="providerState"
            :default="providerName"
            :externalsrc="srcProviders"
            limit-chars="2"
            v-on:choosed="providerChoosed"
            v-on:empty="providerEmpty"
          />
          <div v-if="providerState === false" class="form-card__error">
            Debe seleccionar un Proveedor
          </div>
          <div v-else class="form-card__hint">Campo obligatorio</div>
        </div>

        <div class="form-card__field">
          <label class="form-card__label">Cliente</label>
          <typeahead
            :key="'client-' + formKey"
            :name="'client'"
            :placeh="'Buscar cliente por nombre...'"
            :clean-on="false"
            :default="clientName"
            :externalsrc="srcClients"
            limit-chars="2"
            v-on:choosed="clientChoosed"
            v-on:empty="clientEmpty"
          />
        </div>
      </form>
    </div>

    <div class="form-card__footer">
      <button
        type="button"
        class="form-card__btn form-card__btn--primary"
        :disabled="!canSave || isLoading"
        @click="saveSerialNumber()"
      >
        <i class="bi bi-check-lg"></i>
        {{ serialNumber.id == null ? 'Guardar Nro de Serie' : 'Editar Nro de Serie' }}
      </button>
    </div>
  </div>
</template>

<script>
import typeahead from './../../../global/Typeahead.vue';

export default {
  props: ['productId','serialNumberId'],
  components: {
    typeahead
  },
  data: function () {
    return {
      isLoading: false,
      serialNumber: {
        id: null,
        code: "",
        product_id: this.productId,
        provider_id : null,
      },
      srcProviders: '/api/providers/getProviders',
      srcClients: '/api/clients/getClients',
      serialNumbersApiRoute : "/api/serialnumbers/",
      formKey: 0
    };
  },

  computed: {
    codeState() {
      return this.serialNumber.code.length < 3 ? false : null;
    },
    providerState() {
      return this.serialNumber.provider_id == null  ? false : null ;
    },
    providerName() {
      return this.serialNumber.provider == undefined? '': this.serialNumber.provider.name;
    },
    clientName() {
      return this.serialNumber.client == undefined? '': this.serialNumber.client.name;
    },
    canSave() {
      return this.codeState === null && this.providerState === null;
    },
  },
  watch: {
    serialNumberId: {
      handler: function (serialNumberId) {
        if(serialNumberId != null)
          this.getSerialNumber(serialNumberId);
        else
          this.serialNumber = this.getNewSerialNumber();
      }
    }
  },
  methods: {
    getNewSerialNumber() { 
      return {
        id: null,
        code: "",
        product_id: this.productId,
        provider_id : null
        }
      },
    getSerialNumber(id) {
      var vm = this;
      vm.isLoading = true
      this.$http.get(this.serialNumbersApiRoute + "getSerialNumber/" + id).then((response) => {
        this.serialNumber = response.data.data;
        this.$emit('loaded');
      }).finally(() => {
        vm.isLoading = false
      });
    },
    providerChoosed(data) {
      this.serialNumber.provider_id = data.id;
    },
    providerEmpty(){
        this.serialNumber.provider_id = null;
    },
    clientChoosed(data) {
      this.serialNumber.client_id = data.id;
    },
    clientEmpty(){
        this.serialNumber.client_id = null;
    },
    resetForm() {
      this.serialNumber = this.getNewSerialNumber();
      this.formKey++;
    },
    saveSerialNumber() {
      if (!this.canSave || this.isLoading) return;
      this.$emit('saving');
      this.serialNumber.product_id= this.productId;
      this.isLoading = true
      if (this.serialNumber.id != null) {
        this.$http
            .post(this.serialNumbersApiRoute + "edit/" + this.serialNumber.id, this.serialNumber)
            .then(() => {
              this.resetForm();
              this.$emit('saved');
            })
            .finally(() => {
              this.isLoading = false;
            });
      } else {
        this.$http.post(this.serialNumbersApiRoute + "add", this.serialNumber).then(() => {
          this.resetForm();
          this.$emit('saved');
        })
        .finally(() => {
          this.isLoading = false;
        });
      }
    }
  },
};
</script>

